<template>
  <div>
    <v-container
      class="#F1F2F1"
      style="height: 100%"
      fluid
      :class="$vuetify.breakpoint.width < 330 ? 'pa-4 ma-0' : $vuetify.breakpoint.xs ? 'pa-6 ma-0' : 'pa-8 ma-0'"
    >
      <v-row>
        <v-col cols="12" sm="6" md="4" lg="3" class="py-2">
          <v-card class="pa-2 primary4" style="border-radius: 20px !important;" outlined>
            <v-card-text :class="$vuetify.breakpoint.width <= 330 ? 'pb-0' : ''">
              <div class="text-center">
                <simple-svg
                  :filepath="require('../../assets/imgs_unimed/predio-comercial.svg')"
                  :width="'56px'"
                  :height="'56px'"
                  :fill="$vuetify.theme.themes.light.primary1"
                />

                <div class="title font-weight-bold primary1--text">Minha Unimed</div>

                <div class="subtitle-2 text-start pt-8">
                  <div v-if="!loadingUnimed">
                    <div class="mb-1 font-secundaria" v-for="(minha, index) in minhaUnimed" :key="index">
                      <span class="primary1--text font-weight-bold">{{ minha.bold }}</span> {{ minha.msg }}
                    </div>
                  </div>

                  <v-row v-else align="center" justify="center">
                    <v-col cols="auto">
                      <spinner-cadu size="50" :line-fg-color="$vuetify.theme.themes.light.primary1" />
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-card-text>

            <v-card-actions>
              <v-row justify="center" align="start">
                <v-col cols="auto">
                  <button-cadu
                    name="btnVisualizar"
                    :width="113"
                    @click="visualizar()"
                    :color="$vuetify.theme.themes.light.primary1"
                    class="font-secundaria"
                    text="VISUALIZAR"
                  />
                </v-col>

                <v-col cols="auto" v-if="canEdit">
                  <button-cadu name="btnEditar" :width="113" text="EDITAR" @click="editar()" />
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="8" class="py-2">
          <v-row align="stretch" style="height: 100%">
            <v-col
              v-for="(card, index) in computedList"
              :key="index"
              :class="computedRow(index)"
              cols="12"
              sm="6"
              md="3"
            >
              <CardGeneric :icon="card.icon" :msg="card.msg" :id="card.id" class="mt-0" />
            </v-col>
          </v-row>
        </v-col>

        <v-col v-if="$vuetify.breakpoint.sm">
          <v-row>
            <v-col
              v-for="(card, index) in cardsList.filter((el, index) => el.roles.includes(role) && index > 3)"
              :class="$vuetify.breakpoint.sm ? 'pt-4' : ''"
              :key="index"
              class="py-0"
              cols="12"
              sm="6"
              md="3"
            >
              <CardGeneric :icon="card.icon" :msg="card.msg" :id="card.id" class="mt-0" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      
      <v-row>
        <notification-card
          :notificacoes="notificacoes"
          :notificacoesPaginacao="notificacoesPaginacao"
          :pageNotificacao="pageNotificacao"
          :loadingNotificacao="loadingNotificacao"
          :canViewNotification="canViewNotification"
          :colorPagination="colorPagination"
          @redirectNotification="redirecionarNotificacao"
          @changePage="changePage"
        />

        <updates-card
          :unimedId="this.$idUnimed"
          :appConfig="this.$appConfig.config.API"
         />

      </v-row>

    </v-container>

    <overlay-loading v-model="loadingAll" />

    <error-modal v-model="showError" :errObj="errObj" :titulo="normalErr ? 'Atualização' : 'Há algo errado.'">
      <div slot="footer-buttons">
        <v-row v-if="normalErr">
          <v-col cols="auto">
            <button-cadu @click="showError = false"> NÃO </button-cadu>
          </v-col>

          <v-col cols="auto">
            <button-cadu @click="visualizar"> SIM </button-cadu>
          </v-col>
        </v-row>

        <v-row v-if="edicaoErr">
          <v-col cols="auto">
            <button-cadu outline @click="showError = false"> CANCELAR </button-cadu>
          </v-col>

          <v-col cols="auto">
            <button-cadu @click="visualizar"> CONTINUAR </button-cadu>
          </v-col>
        </v-row>
      </div>
    </error-modal>
  </div>
</template>

<script>
import CardGeneric from './shared/CardGeneric'
import Usuario from '@/services/Usuario'
import Unimed from '@/services/Unimed'
import Pendencia from '@/services/Pendencia/Pendencia'
import jwtDecode from 'jwt-decode'
import { EventBus } from '@/services/EventBus/EventBus'
import Notificacoes from '@/services/Notificacoes/Notificacoes'
import Redirect from '@/services/Redirect'
import NotificationCard from './shared/NotificationCard'
import UpdatesCard from './shared/UpdatesCard.vue'

export default {
  name: 'HomeCadu',

  components: {
    CardGeneric,
    NotificationCard,
    UpdatesCard
  },

  data() {
    return {
      loadingUnimed: false,

      minhaUnimed: [
        { bold: 'Unimed: ', msg: String },
        { bold: 'Tipo de Cooperativa: ', msg: String },
        { bold: 'Tipo de Atuação: ', msg: String },
        { bold: 'Última Atualização: ', msg: String },
        { bold: 'Versão Ativa: ', msg: String }
      ],

      cardsList: [
        {
          icon: 'monitor',
          msg: 'Consultar Unimeds',
          id: 0,
          roles: ['admin_brasil', 'admin', 'colaborador_brasil', 'colaborador_dirigente', 'colaborador', 'dirigente']
        },
        { icon: 'layers', msg: 'Cooperados', id: 1, roles: [] },
        { icon: 'users', msg: 'Dirigentes', id: 2, roles: ['admin_brasil', 'dirigente', 'colaborador_dirigente'] },
        {
          icon: 'clipboard',
          msg: 'Relatórios',
          id: 3,
          roles: ['admin_brasil', 'admin', 'colaborador_brasil', 'colaborador_dirigente', 'colaborador', 'dirigente']
        },
        {
          icon: 'settings',
          msg: 'Administração',
          id: 4,
          roles: ['admin_brasil', 'admin', 'colaborador_brasil', 'colaborador_dirigente', 'colaborador', 'dirigente']
        },
        { icon: 'refresh-ccw', msg: 'Transações Online', id: 5, roles: ['admin_brasil'] },
        { icon: 'inbox', msg: 'Pendências', id: 6, roles: ['admin_brasil'] },
        {
          icon: 'heart',
          msg: 'Cadbenef',
          id: 7,
          roles: ['admin_brasil', 'admin', 'colaborador_brasil', 'colaborador_dirigente', 'colaborador', 'dirigente']
        }
      ],

      notificacoes: [
        { msg: 'Há uma pendência na sua caixa de entrada', color: 'warningUtil1' },
        { msg: 'Um novo recibo foi gerado', color: 'warningUtil1' },
        { msg: 'Um novo perfil logou', color: 'warningUtil2' },
        { msg: 'Um novo recibo foi gerado', color: 'warningUtil1' }
      ],

      tokenBearer: String,
      data: new FormData(),
      role: '',
      acessoCadBenef: Boolean,
      idUnimed: -1,
      showError: false,
      errObj: { status: 'Status', error: 'Error' },
      loadingAll: false,
      unimed: false,
      normalErr: false,
      edicaoErr: false,
      polling: null,
      pageNotificacao: 1,
      notificacoesPaginacao: {},
      colorPagination: '#00995d',
      totalPendencias: 0,
      loadingNotificacao: false
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)

    this.acessoCadBenef = decoded.acessoCadBenef
    this.role = decoded.role

    if (!this.acessoCadBenef) {
      this.cardsList.pop()
    }

    this.minhaUnimedDados()

    if (localStorage.getItem('optionEdit')) {
      this.unimedCancelar()
      localStorage.setItem('optionEdit', false)
    }

    await this.carregaNotificacoes(this.pageNotificacao)
    await this.atualizaQuantPendencias()
    EventBus.$emit('atualizarAlertas')

    this.polling = setInterval(async () => {
      await this.atualizaQuantPendencias()
    }, 300000)
  },
  beforeDestroy() {
    clearInterval(this.polling)
    EventBus.$off('visualizarUnimed')
    EventBus.$off('geradaNovaNotificacao')
  },
  beforeCreate() {
    EventBus.$on('geradaNovaNotificacao', () => {
      document.location.reload(true)
    })
    EventBus.$on('editarVersaoUnimed', (redirectData) => {
      this.editar(redirectData)
    })
  },
  methods: {
    async unimedCancelar() {
      let unimed = new Unimed(this.tokenBearer, this.$appConfig.config.API)

      try {
        await unimed.putCancelEdit()
      } catch (err) {
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        this.showError = true
        this.normalErr = false
      }
    },
    async minhaUnimedDados() {
      let usuario = new Usuario(this.tokenBearer, this.$appConfig.config.API)
      this.loadingUnimed = true

      try {
        let responseUnimed = await usuario.getUnimed()

        responseUnimed = responseUnimed.data

        let codigo = responseUnimed.codigo
        let nomeFantasia = responseUnimed.nomeFantasia
        let nomeCooperativa = responseUnimed.tipoUnimed ? responseUnimed.tipoUnimed.nome : ''
        let nomeAtuacao = responseUnimed.tipoAtuacao ? responseUnimed.tipoAtuacao.nome : ''
        let dtCriacao = responseUnimed.dataUltimaAtualizacao
          ? responseUnimed.dataUltimaAtualizacao.substring(0, 10)
          : ''
        let nrVersao = responseUnimed.numeroVersao

        this.minhaUnimed[0].msg = codigo && nomeFantasia ? `${codigo} - ${nomeFantasia}` : ''
        this.minhaUnimed[1].msg = nomeCooperativa ? `${nomeCooperativa}` : ''
        this.minhaUnimed[2].msg = nomeAtuacao ? `${nomeAtuacao}` : ''
        this.minhaUnimed[3].msg = dtCriacao ? `${dtCriacao}` : ''
        this.minhaUnimed[4].msg = nrVersao ? `${nrVersao}` : ''
        this.idUnimed = responseUnimed.id;

        
        this.loadingUnimed = false
      } catch (err) {
        this.$router.push('/erro')
      }
    },
    async editar() {
      this.unimed = true
      this.loadingAll = true
      localStorage.setItem('optionEdit', this.unimed)

      let unimed = new Unimed(this.tokenBearer, this.$appConfig.config.API)

      try {
        await unimed.putStartEdit(this.idUnimed)
        this.loadingAll = false
        EventBus.$emit('breadCrumbPast', 0)
        this.$router.push({ name: 'minhaunimed', params: { idUnimed: this.idUnimed } })
      } catch (err) {
        const msg = err.response.data.message
        const status = err.response.status
        this.errObj.status = status
        this.errObj.error = msg

        if (status !== 500) {
          if (msg.includes('pendente')) this.normalErr = true
          else this.edicaoErr = true
        }
        
        this.showError = true
        this.loadingAll = false
      }
    },
    async atualizaQuantPendencias() {
      let pendencia = new Pendencia(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await pendencia
        .getPendenciasTotais()
        .then((res) => {
          this.cardsList.find((it) => {
            if (it.id === 6) {
              it.msg = `Pendências (${res.data})`
            }
          })
        })
        .catch((err) => {
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
          this.showError = true
          this.normalErr = false
        })
    },
    visualizar() {
      this.loadingAll = true
      this.unimed = false
      localStorage.setItem('optionEdit', this.unimed)
      EventBus.$emit('breadCrumbPast', 0)
      this.$router.push({ name: 'minhaunimed', params: { idUnimed: this.idUnimed } })
    },
    computedRow(index) {
      return this.$vuetify.breakpoint.sm
        ? index === 0 || index === 1
          ? 'pt-0'
          : 'py-0 mt-4'
        : this.$vuetify.breakpoint.mdAndUp && index >= 0 && index < 4
        ? 'pt-0'
        : 'py-0 mt-4'
    },
    redirecionarNotificacao(notificacao) {
      const currentRoute = this.$router.history.current.path
      const redirectService = new Redirect(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
      const redirectItem = redirectService.getRedirectNotification(notificacao.tipoAlerta.valor)
      const currentPageItem = '/' + redirectItem.name
      if (currentRoute === currentPageItem && redirectItem.name === 'minhaunimed' && redirectItem.tab === 'historico') {
        EventBus.$emit('changeAbaMinhaUnimed', redirectItem)
      } else if (redirectItem.name === 'minhaunimed' && redirectItem.tab === 'historico') {
        this.$router.push({ name: redirectItem.name, params: { idUnimed: this.idUnimed, currentTab: redirectItem } })
      } else if (redirectItem.name === 'minhaunimed' && redirectItem.tab !== 'historico') {
        this.editar(redirectItem)
      } else {
        this.$router.push({ name: redirectItem.name })
      }
    },
    async carregaNotificacoes(page) {
      let userCadu = JSON.parse(localStorage.getItem('user_cadu'))
      const notificacoes = new Notificacoes(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
      this.loadingNotificacao = true
      this.notificacoes = []
      await notificacoes
        .getNotificacoes(userCadu.unimedSelecionada, page)
        .then(({ data }) => {
          this.notificacoesPaginacao = data
          this.pageNotificacao = data.pagina
          this.notificacoes = data.conteudo.sort((a, b) => {
            if (a.competencia !== null && b.competencia !== null) {
              return a.competencia.localeCompare(b.competencia)
            }
          })
          this.loadingNotificacao = false
        })
        .catch((err) => {
          this.loadingNotificacao = false
          this.notificacoes = []
          this.setError(err)
        })
    },
    async changePage(pageIndex) {
      await this.carregaNotificacoes(pageIndex)
    }
  },

  computed: {
    sizeCardNotificacao() {
      return {
        'block-size200': this.notificacoes.length >= 5,
        'block-size70': this.notificacoes.length < 5
      }
    },
    computedList() {
      return this.cardsList.filter((el, index) => {
        return this.$vuetify.breakpoint.sm ? el.roles.includes(this.role) && index < 4 : el.roles.includes(this.role)
      })
    },
    canEdit() {
      return this.role === 'admin_brasil' || this.role === 'admin' || this.role === 'dirigente'
    },
    canViewNotification() {
      const allowedRoles = ['admin_brasil', 'admin', 'dirigente']
      return allowedRoles.indexOf(this.role) !== -1
    }
  }
}
</script>

<style scoped>
.under {
  text-decoration: underline !important;
}

.card-radius {
  border-radius: 20px !important;
}

.block-size200 {
  min-height: 200px;
}

.block-size70 {
  min-height: 70px;
}

.v-application--is-ltr .v-list--shaped .v-list-item,
.v-application--is-ltr .v-list--shaped .v-list-item::before,
.v-application--is-ltr .v-list--shaped .v-ripple__container {
  border-bottom-left-radius: 32px !important;
  border-top-left-radius: 32px !important;
}
.v-application .caption {
  font-size: 0.75rem !important;
  font-weight: 400;
  letter-spacing: 0.0333333333em !important;
  line-height: 0.9rem;
}
</style>
